import * as z from 'zod';
import { financialPeriodPreparationMethodSchema, periodTypeSchema } from '../../../enums.mjs';
import '../../../types/actor/actor.mjs';
import '../../../types/address/address.mjs';
import '../../../types/credit-report/company-credit-report.mjs';
import '../../../types/credit-report/individual-credit-report.mjs';
import '../../../types/currency/currency.mjs';
import '../../../types/entityRelation/entity-relation.mjs';
import '../../../types/financial-formula/adjustable-value.mjs';
import '../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../types/financial-formula/adjustment.mjs';
import '../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../types/is-encrypted.mjs';
import '../../../types/naics-codes/naics-codes.mjs';
import { isoDateTimeSchema, suretyAccountId, isoDateSchema, financialPeriodId, incomeStatementId, balanceSheetId, companyContactId } from '../../../types/opaque.mjs';
import '../../../types/surety/account/surety-account.types.mjs';
import '../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../types/surety/bond/surety-bond.types.mjs';
import '../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../types/surety/contract/contract-extraction-webhook.mjs';
import { BalanceSheetData } from '../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import { IncomeStatementData } from '../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../types/surety/quote/surety-quote.types.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../types/user/user.types.mjs';
import { currencySchema } from '../../../types/utils.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            id: financialPeriodId,
            periodStartDate: isoDateSchema.optional(),
            periodEndDate: isoDateSchema,
            periodType: periodTypeSchema,
            year: z.number(),
            suretyAccountId: suretyAccountId,
            companyContactId: companyContactId.optional(),
            companyName: z.string().optional(),
            preparationMethod: financialPeriodPreparationMethodSchema,
            activeBalanceSheetId: balanceSheetId.optional(),
            activeIncomeStatementId: incomeStatementId.optional(),
            givenBalanceSheet: BalanceSheetData.schema.optional(),
            givenIncomeStatement: IncomeStatementData.schema.optional(),
            blocSize: z.number().optional(),
            profitable: z.boolean().optional(),
            createdAt: isoDateTimeSchema,
            updatedAt: isoDateTimeSchema,
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var List;
(function (List) {
    (function (Response) {
        Response.schema = z.array(Get.Response.schema);
    })(List.Response || (List.Response = {}));
})(List || (List = {}));
var CreateForm;
(function (CreateForm) {
    (function (Request) {
        Request.schema = z.object({
            periodEndDate: isoDateSchema,
            periodType: periodTypeSchema,
            preparationMethod: financialPeriodPreparationMethodSchema,
        });
    })(CreateForm.Request || (CreateForm.Request = {}));
})(CreateForm || (CreateForm = {}));
var Update;
(function (Update) {
    (function (BlocSize) {
        (function (Request) {
            Request.schema = z.object({
                blocSize: currencySchema.nullable(),
            });
        })(BlocSize.Request || (BlocSize.Request = {}));
        (function (Response) {
            Response.schema = Get.Response.schema;
        })(BlocSize.Response || (BlocSize.Response = {}));
    })(Update.BlocSize || (Update.BlocSize = {}));
    (function (Profitability) {
        (function (Request) {
            Request.schema = z.object({
                profitable: z.boolean(),
            });
        })(Profitability.Request || (Profitability.Request = {}));
        (function (Response) {
            Response.schema = Get.Response.schema;
        })(Profitability.Response || (Profitability.Response = {}));
    })(Update.Profitability || (Update.Profitability = {}));
    (function (AccountBlocSize) {
        (function (Request) {
            Request.schema = z.object({
                blocSize: currencySchema.nullable(),
            });
        })(AccountBlocSize.Request || (AccountBlocSize.Request = {}));
        (function (Response) {
            Response.schema = z.array(Get.Response.schema);
        })(AccountBlocSize.Response || (AccountBlocSize.Response = {}));
    })(Update.AccountBlocSize || (Update.AccountBlocSize = {}));
})(Update || (Update = {}));

export { CreateForm, Get, List, Update };
